import React from "react";

const CreateTrainingTypeIcon = ({ fill }) => {
  return (
    <svg
      id="db41"
      xmlns="http://www.w3.org/2000/svg"
      width="17.406"
      height="17.406"
      viewBox="0 0 17.406 17.406"
    >
      <path
        id="Path_1280"
        data-name="Path 1280"
        d="M182.27,291.092v1.088h17.406V279.125H182.27Zm4.64-10.335h0a1.712,1.712,0,1,1-1.212.5,1.713,1.713,0,0,1,1.212-.5Zm-2.083,4.351h4.161a.915.915,0,0,1,.441.114l.076.043h.005c.038.027.076.049.114.082l2.508,2.138,2.638-2.257a.924.924,0,1,1,1.2,1.4l-3.236,2.774a.922.922,0,0,1-1.2,0l-1.621-1.382v3.068H183.9v-5.059a.924.924,0,0,1,.925-.925Z"
        transform="translate(-182.27 -274.774)"
        fill={fill ? fill : "#000"}
      />
      <path
        id="Path_1281"
        data-name="Path 1281"
        d="M182.27,182.27v3.264h17.406V182.27Zm1.632,2.176a.544.544,0,1,1,.544-.544.544.544,0,0,1-.544.544Zm2.176,0a.544.544,0,1,1,.544-.544.544.544,0,0,1-.544.544Zm2.176,0a.544.544,0,1,1,.544-.544.544.544,0,0,1-.544.544Zm10.335,0H192.6v-1.088h5.984Z"
        transform="translate(-182.27 -182.27)"
        fill={fill ? fill : "#000"}
      />
    </svg>
  );
};

export default CreateTrainingTypeIcon;
